/* Great Spirit PDP v2 — UGC video slider + "Read the reviews" link. Loaded after gs-pdp.js. */
(function () {
  if (window.__gsPdpV2) return;
  window.__gsPdpV2 = true;

  /* ---------- "Read the reviews" → scroll to the reviews section ---------- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-gs-scroll-to-reviews]');
    if (!link) return;
    var target = document.querySelector('[data-gs-reviews]');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- Video slider ---------- */
  function initSlider(root) {
    if (root.__gs) return; root.__gs = true;
    var track = root.querySelector('[data-gs-track]');
    var nav = root.querySelector('[data-gs-nav]');
    var prev = root.querySelector('[data-gs-prev]');
    var next = root.querySelector('[data-gs-next]');
    var dotsEl = root.querySelector('[data-gs-dots]');
    if (!track || !nav) return;
    var pages = 1;
    function step() { var card = track.firstElementChild; if (!card) return track.clientWidth; var gap = parseFloat(getComputedStyle(track).columnGap) || 16; var per = Math.max(1, Math.floor((track.clientWidth + gap) / (card.offsetWidth + gap))); return per * (card.offsetWidth + gap); }
    function build() {
      var max = track.scrollWidth - track.clientWidth;
      pages = max > 4 ? Math.ceil(max / step()) + 1 : 1;
      nav.hidden = pages < 2;
      dotsEl.innerHTML = '';
      for (var i = 0; i < pages; i++) {
        var b = document.createElement('button');
        b.type = 'button'; b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        (function (n) { b.addEventListener('click', function () { track.scrollTo({ left: Math.min(n * step(), track.scrollWidth - track.clientWidth) }); }); })(i);
        dotsEl.appendChild(b);
      }
      update();
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var x = track.scrollLeft;
      var idx = x >= max - 4 ? pages - 1 : Math.round(x / step());
      Array.prototype.forEach.call(dotsEl.children, function (d, i) { d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
      prev.disabled = x <= 4;
      next.disabled = x >= max - 4;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step() }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step() }); });
    var t; track.addEventListener('scroll', function () { cancelAnimationFrame(t); t = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', build);
    build();
  }

  function init(root) { (root || document).querySelectorAll('[data-gs-slider]').forEach(initSlider); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
